import request from '@/utils/request'

// 查询列表 通过编号
export function getGoodsListReq(query) {
  return request({
    url: '/api/order/getGoodsList',
    method: 'GET',
    params: query , //params修改为data
  })
}

//获取优惠券信息
export function getUseStatusCouponListReq(query) {
  return request({
    url: '/api/coupon/getUseStatusCouponList',
    method: 'GET',
    params: query , //params修改为data
  })
}
//获取优惠券信息
export function getPromotionPriceReq(query) {
  return request({
    url: '/api/promotion/getPromotionPrice',
    method: 'GET',
    params: query , //params修改为data
  })
}

//获取相关费用
export function getPostagePriceReq(query) {
  return request({
    url: '/api/order/getPostagePrice',
    method: 'GET',
    params: query , //params修改为data
  })
}

